/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AiAssistantEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AI_ASSISTANT_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AiAssistantEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AiAssistantEnabledSettingParser.decode(input).map(res => new AiAssistantEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return AiAssistantEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AiAssistantEnabledSettingParser.encode(data);
    }
    static schema() {
        return AiAssistantEnabledSettingParser.schema();
    }
}
